export default __webpack_public_path__ + "static/media/communitiy-home-carousel.4d437753.jpg";